import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { RowActionsMenu } from '@/components/ui/RowActionsMenu';

import { State } from '../State';

export function RowActionsMenuExamples() {
  const [chosen, setChosen] = useState<string | null>(null);

  return (
    <State
      title="One row's actions behind one control"
      note="Named for its row, so forty of them down a table do not all read alike."
    >
      <RowActionsMenu
        rowLabel="Clean Rivers Pledge"
        actions={[
          { label: 'Open', onSelect: () => setChosen('Open') },
          { label: 'Change status', onSelect: () => setChosen('Change status') },
          { label: 'Archive', onSelect: () => setChosen('Archive'), disabled: true },
        ]}
      />
      <Typography variant="body2" color="text.secondary">
        {chosen ? `Chosen: ${chosen}` : 'Nothing chosen yet.'}
      </Typography>
    </State>
  );
}
